export default "__VITE_ASSET__73a521c1__"